/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="register-page-container">
    <div cols="8" class="register-form-block">
      <div class="d-flex align-items-center justify-content-center">
        <svg class="o-icon mr-3 fill-black"><use xlink:href="#user-guest"></use></svg>
        <h1 class="title title-small mb-0 cl-black">{{ $t('create-your-account') }}</h1>
      </div>
      <form @submit.stop.prevent="handleSubmit" class="register-form">
        <b-row>
          <b-col cols="6">
            <b-form-group id="groupFirstname" label-for="firstname">
              <base-input
                name="firstname"
                v-validate="'required'"
                v-model="form.firstname"
                type="text"
                classInput="rounded"
                :placeholder="$t('address.FirstName') + '*'"
                :validations="[
                  {
                    condition: errors.has('firstname'),
                    text: errors.first('firstname')
                  }
                ]"
              >
              </base-input>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group id="groupLastname" label-for="lastname">
              <base-input
                name="lastname"
                v-validate="'required'"
                v-model="form.lastname"
                type="text"
                classInput="rounded"
                :placeholder="$t('address.LastName') + '*'"
                :validations="[
                  {
                    condition: errors.has('lastname'),
                    text: errors.first('lastname')
                  }
                ]"
              >
              </base-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-form-group id="groupEmail" label-for="email">
              <base-input
                name="email"
                v-validate="'required|email'"
                v-model="form.email"
                type="text"
                classInput="rounded"
                @blur="checkIfExist"
                :placeholder="$t('address.Email') + '*'"
                :validations="[
                  {
                    condition: errors.has('email') || emailExist,
                    text: errors.first('email')
                  }
                ]"
              >
              </base-input>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <input-dob
              name="dob"
              v-model="form.dob"
              id="dob"
              v-validate="'required|dob:18'"
              :validations="[
                {
                  condition: errors.has('dob'),
                  text: errors.first('dob')
                }
              ]">
            </input-dob>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-form-group id="groupPasswordConfirm" label-for="coin-card">
              <base-input
                name="coin-card"
                :data-vv-as="$t('coin-card')"
                v-model="form.coinCard"
                type="text"
                classInput="rounded"
                :placeholder="$t('coin-card')"
                :validations="[
                  {
                    condition: errors.has('coin-card'),
                    text: errors.first('coin-card')
                  }
                ]"
              >
              </base-input>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group id="groupPassword" label-for="password">
              <base-input
                name="password"
                :data-vv-as="$t('Password')"
                v-validate="'min:8|passwordM'"
                v-model="form.password"
                ref='pw_confirm'
                type="password"
                classInput="rounded"
                autocomplete="new-password"
                :placeholder="$t('Password')"
                :validations="[
                  {
                    condition: errors.has('password'),
                    text: errors.first('password')
                  }
                ]"
              >
              </base-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="block-privacy">
            <div v-for="(value, key) in form.privacy" :key="key" class="privacy-terms text-center">
              <b-form-group :id="'checkbox_'+key" :label-for="key" class="privacy-check check-wrapped my-2" :class="{ 'is-invalid': errors.has(key) }">
                <base-check-box
                  :name="key"
                  :key="key"
                  v-validate="(privacyMandatory[key] ? 'required:true' : '')"
                  v-model="form.privacy[key]"
                  :label="labelCheckbox[key]"
                  :validations="[
                    {
                      condition: errors.has(key),
                      text: errors.first(key)
                    }
                  ]"
                >
                </base-check-box>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
        <div class="block-submit text-center">
          <button type="submit" class="btn btn-primary btn-primary-large btn-primary-with-icon btn-primary-black btn-rounded text-inherit" :disabled="emailExist">
            <span class="text">{{ $t('create-your-account') }}</span>
            <svg class="o-icon fill-white"><use xlink:href="#user-guest"></use></svg>
          </button>
        </div>
        <div class="form-errors is-invalid" v-show="serverValidation">
          <p v-html="serverValidation"></p>
        </div>
      </form>
    </div>
    <absolute-loader :showLoader="showLoader" />
  </div>
</template>

<script>
import AbsoluteLoader from 'theme/components/AbsoluteLoader/AbsoluteLoader'
import BaseInput from 'theme/components/Form/BaseInput'
import BaseCheckBox from 'theme/components/Form/BaseCheckBox'
import InputDob from 'theme/components/Form/Dob'
import Breadcrumb from 'theme/components/Breadcrumb/Breadcrumb'
import Config from 'config'
import { toast } from 'theme/modules/notifications'
import { scrollTo } from '@/helpers'
import { axiosErrorMessage } from '@/helpers/utils'

export default {
  $_veeValidate: {
    validator: 'new'
  },
  name: 'Register',
  data () {
    return {
      showLoader: false,
      emailExist: false,
      serverValidation: false,
      modalTerms: {
        open: false,
        pageID: ''
      },
      form: {
        firstname: '',
        lastname: '',
        email: '',
        telephone: '',
        dob: '',
        coinCard: '',
        password: '',
        index: 1,
        privacy: {
          terms1: false,
          terms2: false,
          terms3: false
        }
      },
      privacyMandatory: { 'terms1': true }
    }
  },
  computed: {
    labelCheckbox () {
      const linkPrivacy = Config.Theme.linkUtils.linkPrivacy
      return {
        'terms1': this.$t('register-page.terms-privacy', { linkPrivacy }),
        'terms2': this.$t('register-page.terms-marketing'),
        'terms3': this.$t('register-page.terms-profiling')
      }
    }
  },
  methods: {
    checkIfExist () {
      this.$store.dispatch('userAdmin/isEmailAvailable', { email: this.form.email })
        .then((isAvailable) => {
          // res = false email exist
          // res = true email doesen't exist
          if (!isAvailable) {
            toast.error(this.$t('user-already-exist'))
            this.emailExist = true
          } else {
            this.emailExist = false
          }
        })
    },
    clearForm () {
      this.form.firstname = this.form.lastname = this.form.email = this.form.password = this.form.dob = this.form.coinCard = ''
      this.form.privacy.terms1 = this.form.privacy.terms2 = this.form.privacy.terms3 = false
      this.$validator.reset()
      document.querySelector('input[name="firstname"]').focus()
    },
    handleSubmit (evt) {
      const _this = this
      if (evt) { evt.preventDefault() }
      _this.serverValidation = ''
      return this.$validator.validate().then(isValid => {
        if (isValid) {
          _this.showLoader = true
          _this.$store.dispatch('userAdmin/create', _this.form)
            .then(() => {
              _this.showLoader = false
              toast.success(_this.$t('user-created'))
              _this.serverValidation = ''
              _this.clearForm()
            })
            .catch((err) => {
              _this.showLoader = false
              _this.serverValidation = _this.$t(axiosErrorMessage(err))
            })
        } else {
          scrollTo({
            className: 'is-invalid'
          })
        }
      })
    }
  },
  components: {
    AbsoluteLoader,
    BaseInput,
    BaseCheckBox,
    Breadcrumb,
    InputDob
  }
}
</script>
